var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.9705,
    cy: 46.7998,
    r: 25.74,
    stroke: "white",
    strokeWidth: 2.34
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.3792,
    cy: 35.8798,
    r: 3.51,
    stroke: "white",
    strokeWidth: 2.34
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0999,
    cy: 46.7999,
    r: 3.51,
    stroke: "white",
    strokeWidth: 2.34
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.3792,
    cy: 57.7199,
    r: 3.51,
    stroke: "white",
    strokeWidth: 2.34
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.5102,
    cy: 11.3098,
    r: 4.68,
    stroke: "white",
    strokeWidth: 2.34
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.3102,
    cy: 81.5101,
    r: 3.9,
    stroke: "white",
    strokeWidth: 2.34
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.7898,
    cy: 86.9698,
    r: 1.17,
    stroke: "white",
    strokeWidth: 1.56
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.3094,
    cy: 17.5499,
    r: 1.17,
    stroke: "white",
    strokeWidth: 1.56
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.3309,
    cy: 8.18999,
    r: 1.17,
    stroke: "white",
    strokeWidth: 1.56
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.8504,
    cy: 72.1498,
    r: 1.17,
    stroke: "white",
    strokeWidth: 1.56
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.5107,
    cy: 83.8498,
    r: 3.12,
    stroke: "white",
    strokeWidth: 2.34
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.1901 46.7999C86.1901 68.1345 69.0676 85.4099 47.9701 85.4099C26.8726 85.4099 9.75008 68.1345 9.75008 46.7999C9.75008 25.4653 26.8726 8.1899 47.9701 8.1899C69.0676 8.1899 86.1901 25.4653 86.1901 46.7999Z",
    stroke: "white",
    strokeWidth: 2.34
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 47.9708,
    y1: 8.57983,
    x2: 47.9708,
    y2: 20.2798,
    stroke: "white",
    strokeWidth: 2.34
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28.6008,
    y1: 65.5671,
    x2: 20.3276,
    y2: 73.8402,
    stroke: "white",
    strokeWidth: 2.34
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 21.8398,
    y1: 46.4097,
    x2: 10.1398,
    y2: 46.4097,
    stroke: "white",
    strokeWidth: 2.34
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 51.992,
    y1: 37.7122,
    x2: 37.9519,
    y2: 44.5372,
    stroke: "white",
    strokeWidth: 2.34
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 52.0036,
    y1: 56.4357,
    x2: 37.7046,
    y2: 49.41,
    stroke: "white",
    strokeWidth: 2.34
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon-5.1a7c6cd202442cfd3f905e9dd54c7248.svg";
export { ForwardRef as ReactComponent };